import styles from '../../requests/RequestList/RequestList.module.css';
export default function Paginator({ currentPage, handlePageChange, totalPageCount }) {
  const goToPreviousPage = () => {
    if (currentPage > 1) {
      handlePageChange(currentPage - 1);
    }
  };

  const goToNextPage = () => {
    if (currentPage < totalPageCount) {
      handlePageChange(currentPage + 1);
    }
  };

  return (
    <section className={styles.paginatorBar}>
      <div className={styles.paginator}>
        <button onClick={goToPreviousPage} className={styles.paginatorButton} disabled={currentPage === 1}>
          {'<'}
        </button>
        
        <div>
          <input
            type='number'
            value={currentPage}
            onChange={(ev) => {
              const page = parseInt(ev.target.value);
              if (page >= 1 && page <= totalPageCount) {
                handlePageChange(page);
              }
            }}
            className={styles.paginatorInput}
            style={{ width: '70px' }}
            min={1}
            max={totalPageCount}
          />
        </div>
        
        <button onClick={goToNextPage} className={styles.paginatorButton} disabled={currentPage === totalPageCount}>
          {'>'}
        </button>
      </div>
      <div className={styles.pageSelector}>
        <p>
          Página {currentPage} de {totalPageCount}
        </p>
      </div>
    </section>
  );
}